/**
 * PDP: main gallery scroll → thumbnail strip sync (data-slide + active).
 * Standalone; does not modify slider.js. Tune when you go live.
 */
(function () {
    const BOUND = "data-thumb-sync-bound";
  
    function getSlides(track) {
      return Array.from(track.children);
    }
  
    function activeIndexFromScroll(scroller, slides) {
      if (!slides.length) return 0;
      const viewCenter = scroller.scrollLeft + scroller.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      slides.forEach((slide, i) => {
        const mid = slide.offsetLeft + slide.offsetWidth / 2;
        const d = Math.abs(viewCenter - mid);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      });
      return Math.min(slides.length - 1, Math.max(0, best));
    }
  
    function applyThumbState(secondaryScroller, secondarySlides, idx) {
      secondarySlides.forEach((slide, i) => {
        slide.setAttribute("active", i === idx ? "true" : "false");
      });
      const target = secondarySlides[idx];
      if (!target) return;
      secondaryScroller.scrollTo({
        left: target.offsetLeft,
        behavior: "auto",
      });
    }
  
    function bindContainer(container) {
      if (container.getAttribute(BOUND) === "true") return;
  
      const primaryScroller = container.querySelector(
        ".product-media__primary [data-slider]"
      );
      const secondaryScroller = container.querySelector(
        ".product-media__secondary [data-slider]"
      );
      if (!primaryScroller || !secondaryScroller) return;
  
      const slidesP = getSlides(primaryScroller);
      const slidesS = getSlides(secondaryScroller);
      if (!slidesP.length || slidesP.length !== slidesS.length) return;
  
      container.setAttribute(BOUND, "true");
  
      let raf = null;
      const sync = () => {
        const idx = activeIndexFromScroll(primaryScroller, slidesP);
        applyThumbState(secondaryScroller, slidesS, idx);
      };
  
      const onScroll = () => {
        if (raf != null) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          sync();
        });
      };
  
      primaryScroller.addEventListener("scroll", onScroll, { passive: true });
      primaryScroller.addEventListener("scrollend", sync, { passive: true });
    }
  
    function scan() {
      document.querySelectorAll("[data-product-media]").forEach(bindContainer);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", scan);
    } else {
      scan();
    }
  
    const mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  })();
  